import React, { Component } from "react";

import "./style.css";

class Button extends Component {
  click = () => {
    const { onClick, href, newWindow } = this.props;
    if (href)
      if (newWindow) {
        window.open(href, "_blank");
      } else window.location.href = href;
    if (onClick) onClick();
  };

  render() {
    const {
      icon,
      text,
      type = "green",
      className = "",
      newWindow,
      ...props
    } = this.props;

    return (
      <div
        className={`button ${type} ${icon ? "bl-btn-icon" : ""
          } ${className}`}
        {...props}
        onClick={this.click}
      >
        {text}
        {icon && <img alt="" height={16} src={icon} />}
      </div>
    );
  }
}

export default Button;
